import { render } from "./RakutenCard.vue?vue&type=template&id=dd641a4a"
import script from "./RakutenCard.vue?vue&type=script&lang=js"
export * from "./RakutenCard.vue?vue&type=script&lang=js"

import "./RakutenCard.vue?vue&type=style&index=0&id=dd641a4a&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__